// MegaFunZone.com — Flash Game Portal Data
// A Profit Dynamics International™ Distraction Platform

export const MFZ_GAMES = [
  {
    id: 'bloons',
    name: 'Bloons',
    category: 'Puzzle',
    description: 'Pop the required number of balloons using your limited supply of darts. 50 levels of increasingly devious layouts. Chain reactions are key to passing later levels.',
    swfPath: '/games/megafunzone/bloons/bloons.swf',
    thumbBg: '#5c1a3a',
    thumbLabel: 'BLN',
    plays: '12,045,778',
    rating: 4.8,
    votes: 18234,
    featured: true,
    staffPick: true,
    isNew: false,
    year: 2007,
    instructions: 'Click and drag to aim your dart. Release to throw. Pop at least the target number of balloons with your limited darts. Watch out for metal bloons.',
    tags: ['puzzle', 'darts', 'balloons'],
  },
  {
    id: 'desktop-td',
    name: 'Desktop Tower Defense',
    category: 'Strategy',
    description: 'The tower defense game that defined a genre. Place towers on your desktop to stop endless waves of creeps from crossing. Build a maze to maximize the path distance and earn interest between rounds.',
    swfPath: '/games/megafunzone/desktop-td/desktop-td.swf',
    thumbBg: '#1a3a1a',
    thumbLabel: 'DTD',
    plays: '8,902,341',
    rating: 4.9,
    votes: 19234,
    featured: false,
    staffPick: true,
    isNew: false,
    year: 2007,
    instructions: 'Click to place towers. Build a maze to make creeps travel the longest path possible. Sell towers you do not need. Save money for interest bonuses at round end.',
    tags: ['tower-defense', 'strategy', 'waves'],
  },
  {
    id: 'line-rider',
    name: 'Line Rider',
    category: 'Arcade',
    description: 'Draw lines with your mouse and send the little sledder on a wild ride. The physics engine makes every track feel real. Build ramps, loops and death drops.',
    swfPath: '/games/megafunzone/line-rider/line-rider.swf',
    thumbBg: '#1a4a5c',
    thumbLabel: 'LR',
    plays: '9,567,301',
    rating: 4.5,
    votes: 14521,
    featured: false,
    staffPick: false,
    isNew: false,
    year: 2006,
    instructions: 'Select the pencil tool and draw lines on the canvas. Press Play to launch the sledder. Use the eraser to fix mistakes. Build your track then watch him ride.',
    tags: ['drawing', 'physics', 'creative'],
  },
  {
    id: 'motherload',
    name: 'Motherload',
    category: 'Arcade',
    description: 'Pilot your mining pod into the depths of an alien planet. Drill for minerals, return to the surface to sell them, upgrade your hull and engines, and uncover the mystery waiting deep below.',
    swfPath: '/games/megafunzone/motherload/motherload.swf',
    thumbBg: '#3a2a1a',
    thumbLabel: 'ML',
    plays: '6,234,789',
    rating: 4.6,
    votes: 9123,
    featured: false,
    staffPick: false,
    isNew: false,
    year: 2004,
    instructions: 'Arrow keys to fly and drill in any direction. Fly back to the surface to sell minerals at the shop. Buy hull repairs and fuel. Watch both meters carefully.',
    tags: ['mining', 'upgrade', 'exploration'],
  },
];

export const MFZ_CATEGORIES = ['All', 'Arcade', 'Puzzle', 'Strategy'];

export const FEATURED_GAME_ID = 'bloons';
export const DAILY_GAME_ID = 'desktop-td';

export const MFZ_COMMENTS = {
  bloons: [
    { user: 'bloonpop_master',  text: 'level 47 is literally IMPOSSIBLE without the ice dart combo', time: '1 hr ago' },
    { user: 'NinjaKiwi_fan99', text: 'BTD is even better but this is where the bloons universe started. respect', time: '8 hrs ago' },
    { user: 'dartmaster99',    text: 'i popped every single balloon on level 32 with 1 dart. screenshot is on my profile', time: '3 days ago' },
  ],
  'desktop-td': [
    { user: 'TowerGod_v2',    text: 'my maze on round 50 was incredible. squirt + lightning combo is op', time: '45 mins ago' },
    { user: 'DTD_veteran',    text: 'this game single-handedly got me through an entire boring summer', time: '2 hrs ago' },
    { user: 'creepkiller99', text: 'tip: place towers in a zig zag pattern not a straight line for max path length', time: '1 day ago' },
  ],
  'line-rider': [
    { user: 'linerider_pro',   text: 'spent 3 hours building a loop-de-loop track. totally worth it', time: '2 hrs ago' },
    { user: 'sledgod2006',    text: 'try building a jump off a really steep ramp. the physics are insane', time: '6 hrs ago' },
    { user: 'drawmaster_x',  text: 'you can make him do backflips if you get the angle right', time: '2 days ago' },
  ],
  motherload: [
    { user: 'drill_king_99',   text: 'once you get the hull upgrade the game completely opens up', time: '3 hrs ago' },
    { user: 'deepdigger2004', text: 'do not forget to buy fuel before going too deep. learned that the hard way', time: '7 hrs ago' },
    { user: 'mineralman_x',  text: 'the story ending caught me completely off guard. worth it to dig all the way', time: '1 day ago' },
  ],
  default: [
    { user: 'xXFlashFanXx',    text: 'this game is SO addicting i have been here for 3 hours', time: '4 hrs ago' },
    { user: 'gamergirl2007',  text: 'playing this instead of doing homework. totally worth it', time: '1 day ago' },
    { user: 'pro_gamer_4life', text: 'anyone wanna swap AIM screennames? mine is gamerkid2007xoxo', time: '2 days ago' },
  ],
};
